import "./mobileDestination.css";

function MobileDestinationTitle() {
    return <p className="mobile-destination-title">01 <span className="white-text">  PICK YOUR DESTINATION</span></p>
}

export default MobileDestinationTitle;